import * as React from 'react'
import { motion } from 'framer-motion'
import { Box } from '../box'

const MotionBox: React.FC<any> = (props: any): React.ReactElement => {
	const {
		animate,
		initial,
		variants,
		transition,
		animation,
		onAnimationStart,
		onAnimationComplete,
		...rest
	} = props

	const animationProps = animate ? {
		animate,
		initial,
		variants,
		transition,
		onAnimationStart,
		onAnimationComplete
	} : animation

	return (
		<motion.div style={{ width: '100%', height: '100%' }} {...animationProps}>
			<Box width="100%" height="100%" {...rest} />
		</motion.div>
	)
}

export default MotionBox
